var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full",style:({ 'padding-bottom': 100 / _vm.ratio + '%' })},[_c('div',{staticClass:"absolute top-0 left-0 w-full"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }